import { render, staticRenderFns } from "./PTab.vue?vue&type=template&id=6dd51a75&scoped=true&"
import script from "./PTab.vue?vue&type=script&lang=ts&"
export * from "./PTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd51a75",
  null
  
)

export default component.exports